import React from "react";
import { Link } from "react-router-dom";
import "./difficulties.css";
import { connect } from "react-redux";
import { addProblems } from "../../../Redux/action";
import ProfileNavbar from "../../../components/Navbar/ProfileNavbar";
import Footer from "../../../components/Footer/Footer";

const Difficulties = ({ addProblems, problems, state }) => {
  const [difficulties, setDifficulties] = React.useState([]);

  const handleDifficulty = (e) => {
    let difficultyType = e.target.value;
    let found = difficulties.includes(difficultyType);
    if (!found) {
      setDifficulties([...difficulties, difficultyType]);
      addProblems(difficulties);
      //console.log(state);
    } else {
      let newDifficulties = [];
      newDifficulties = difficulties.filter(
        (difficulty) => difficulty !== difficultyType
      );
      setDifficulties(newDifficulties);
      addProblems(newDifficulties);
      //console.log(state);
    }
  };

  return (
    <>
      <ProfileNavbar />
      <div className="difficulties">
        <h1>What kind of problems are you facing?</h1>
        <h3>Select the areas that you need help with.</h3>
        <div className="select-btn-group">
          <div className="buttons-column">
            <label className="container">
              Anxiety
              <input
                type="checkbox"
                value="Anxiety"
                onChange={(e) => handleDifficulty(e)}
              />
              <span className="checkmark"></span>
            </label>

            <label className="container">
              Family Issues
              <input
                type="checkbox"
                value="Family Issues"
                onChange={(e) => handleDifficulty(e)}
              />
              <span className="checkmark"></span>
            </label>

            <label className="container">
              Disability
              <input
                type="checkbox"
                value="Disability"
                onChange={(e) => handleDifficulty(e)}
              />
              <span className="checkmark"></span>
            </label>
          </div>
          <div className="buttons-column">
            <label className="container">
              Depression
              <input
                type="checkbox"
                value="Depression"
                onChange={(e) => handleDifficulty(e)}
              />
              <span className="checkmark"></span>
            </label>

            <label className="container">
              Career Issues
              <input
                type="checkbox"
                value="Career Issues"
                onChange={(e) => handleDifficulty(e)}
              />
              <span className="checkmark"></span>
            </label>

            <label className="container">
              Trauma / Abuse
              <input
                type="checkbox"
                value="Trauma / Abuse"
                onChange={(e) => handleDifficulty(e)}
              />
              <span className="checkmark"></span>
            </label>
          </div>
          <div className="buttons-column">
            <label className="container">
              Self Esteem
              <input
                type="checkbox"
                value="Self Esteem"
                onChange={(e) => handleDifficulty(e)}
              />
              <span className="checkmark"></span>
            </label>

            <label className="container">
              Sexuality Issues
              <input
                type="checkbox"
                value="Sexuality Issues"
                onChange={(e) => handleDifficulty(e)}
              />
              <span className="checkmark"></span>
            </label>

            <label className="container">
              Others
              <input
                type="checkbox"
                value="Others"
                onChange={(e) => handleDifficulty(e)}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>

        <Link to="/gender">
          <button className="continue-btn">Continue</button>
        </Link>
      </div>
      <Footer />
    </>
  );
};

const mapDispatchToProps = { addProblems };
const mapStateToProps = (state) => {
  return {
    state,
    problems: state?.problems,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Difficulties);
